module.exports = __webpack_public_path__ + "img/logo-dark.4101a68c.png";